export const exportFormats = {
  csv: 'text/csv',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export const entityTypes = {
  product: 'productId',
  variant: 'variantId',
  reason: 'reasonId',
  category: 'categoryId',
  type: 'typeId',
  collection: 'collectionId',
}
